import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {graphql} from 'react-apollo';
import {autobind} from 'core-decorators';
import moment from 'moment';
import Spinner from 'components/spinner';
import denProjectQuery from 'graphql/queries/den-project.gql';
import SectionTitle from 'components/section-title';
import styles from './styles.css';

@graphql(denProjectQuery)
@autobind
export default class DEN extends Component {
    handleClick(url) {
        return () => window.open(url);
    }

    render() {
        if (this.props.data.loading) return <Spinner />;
        const project = this.props.data.denProject;

        return (
            <div className={styles.root}>
                <div className={styles.basicInfo}>
                    <div className={styles.section}>
                        <SectionTitle title='¿Qué es el proyecto DEN?' />
                        <div className={styles.text}>
                            <p>
                                La identificación del punto de venta es clave en la identidad visual integral de Nidera
                                Semillas. Mediante el concepto DEN (Diseño de Espacio Nidera) buscamos lograr ambientes
                                 más cálidos y confortables, ofreciendo una experiencia diferente al productor.
                            </p>
                            <p>
                                Con la normalización de las fachadas edilicias se logrará mostrar una imagen homogénea
                                 de la marca Nidera Semillas en RED.IN. La cenefa y el tótem de alta
                                 visibilidad son las piezas fundamentales de esta nueva imagen, que acompañados por
                                 cartelería y letreros, displays y otras identificaciones logrará comunicar y acercar
                                 este nuevo concepto al productor.
                            </p>
                        </div>
                    </div>
                    <div className={styles.section}>
                        <SectionTitle title='¿Cuál es el proceso para participar?' />
                        <div className={styles.text}>
                            <p>
                                Nidera Semillas estableció distintas etapas del Proyecto DEN para poder completar la
                                 identificación de la red en un plazo de 3 años. El proveedor definido por Nidera
                                 Semillas se pondrá en contacto con vos para iniciar el proceso que finalizará con la
                                 identificación, tanto externa como interna, de tu punto de venta.
                            </p>
                            <p>
                                El costo de la implementación del Proyecto DEN será descontado de tu Crédito del Portal
                                 de Marketing, previa aprobación de ambas partes, contemplando que tengas crédito para
                                 realizar acciones de generación de demanda. Todos los procesos de identificación,
                                 armado y colocación correrán por cuenta de Nidera Semillas y será ésta quien se
                                 encargará de abonar el Proyecto DEN para facilitarte el trabajo.
                            </p>
                        </div>
                    </div>
                </div>
                <div className={styles.invitation}>
                    ¡Sumate a este proyecto! ¡Conocé a los RED.IN que ya forman parte de él!
                </div>
                <div className={styles.section}>
                    <SectionTitle title='Etapas del proyecto DEN' />
                    <div className={styles.gridStages}>
                        <div className={styles.stage}>
                            <div className={styles.stageTitle}>
                                <span>1</span><span className={styles.title}>Relevamiento</span>
                            </div>
                            <p className={styles.stageText}>
                                Luego de coordinar con vos día y hora, visitaremos tu punto de venta para
                                tomar fotografías
                                y todas las medidas correspondientes que nos permitan adaptar el proyecto DEN a tu
                                estructura edilicia.
                            </p>
                        </div>
                        <div className={styles.stage}>
                            <div className={styles.stageTitle}>
                                <span>2</span><span className={styles.title}>Presentación</span>
                            </div>
                            <p className={styles.stageText}>
                                Una vez presentado el proyecto, y habiéndonos puesto de acuerdo
                                en las mejoras a realizarse
                                para llevar adelante la implementación del mismo, te enviaremos
                                una minuta de mejoras con
                                todas las indicaciones para que puedas realizar los trabajos previos a la colocación de
                                cartelería y otros elementos gráficos. Luego de aprobado el proyecto presentado, te
                                enviaremos el presupuesto detallado. Aceptado el mismo, iniciamos la producción de todos
                                los materiales al tiempo que vos vas realizando las mejoras que sean necesarias en tu
                                local: pintura, retiro de cartelería existente, etc.
                            </p>
                        </div>
                        <div className={styles.stage}>
                            <div className={styles.stageTitle}>
                                <span>3</span><span className={styles.title}>Producción</span>
                            </div>
                            <p className={styles.stageText}>
                                Con la información recopilada del relevamiento, armamos el proyecto siguiendo los
                                lineamientos generales del concepto DEN, lo compartimos con vos y juntos definimos
                                la mejor alternativa para tu punto de venta. Además, revisaremos todas las mejoras
                                edilicias que tengas que hacerle a tu local para que se adecue a este nuevo concepto.
                            </p>
                        </div>
                        <div className={styles.stage}>
                            <div className={styles.stageTitle}>
                                <span>4</span><span className={styles.title}>Implementación</span>
                            </div>
                            <p className={styles.stageText}>
                                Una vez finalizadas todas estas tareas, fijamos una fecha en la que visitaremos tu punto
                                de venta para comenzar con la colocación de toda la cartelería exterior e interior.
                                En algunos casos realizaremos la colocación de los interiores en una primera etapa y los
                                elementos exteriores en una segunda etapa.
                            </p>
                        </div>
                    </div>
                </div>
                {project && (
                    <div className={styles.section}>
                        <SectionTitle title='Mi proyecto DEN' />
                        <div className={styles.filesGrid}>
                            {project.files.map(file => (
                                <Link key={file.id} to={file.url} target='_blank'>
                                    <span className={styles.fileName}>
                                        <i className='material-icons'>insert_drive_file</i> {file.name}
                                    </span>
                                    <span>{file.category.name} - {moment(file.created).format('DD/MM/YYYY')}</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                )}
                <div className={styles.section}>
                    <SectionTitle title='Galería de fotos' />
                    <div className={styles.gridPictures}>
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/den/index.js